import request from '@/utils/request'
import type { XssCommonPageListQuery, XssCommonPageListResult } from '@/types/public'
import type {
  NameplateReissueListItem,
  NameplateReissueDetail,
  NameplateReissueEquipmentItem,
  NameplateReissueApplyReasonItem,
  ConfirmNameplateReissueParams,
  confirmNameplateReissueData,
  PayNameplateRessiuePrams,
  PayNameplateReissueResult,
} from '@/types/nameplate-reissue'
import { OrderSubmitInvoiceData } from '@/types/invoice'

// 获取三证补办申请列表
export function getNameplateReissueList(
  params: XssCommonPageListQuery
): Promise<XssCommonPageListResult<NameplateReissueListItem>> {
  return request.get('/api/applets/nameplate/index', { params })
}

// 获取三证补办申请单详情
export function getNameplateReissueDetail(guid: string): Promise<NameplateReissueDetail> {
  return request.get(`/api/applets/nameplate/show/${guid}`)
}

// 获取三证补办申请单我的设备
export function getNameplateReissueEquipment(): Promise<Array<NameplateReissueEquipmentItem>> {
  return request.get(`/api/applets/nameplate/equipments`)
}

//获取设备飞控编码
export function getNameplateReissueEquipmentFlyCode(serial_number: string): Promise<string> {
  return request.get(`/api/applets/common/equipments/fc_sn/${serial_number}`)
}

//获取申请原因
export function getNameplateReissueApplyReason(): Promise<NameplateReissueApplyReasonItem> {
  return request.get(`/api/applets/nameplate/reason_type`)
}

//申请铭牌
export function confirmNameplateReissue(
  params: ConfirmNameplateReissueParams
): Promise<confirmNameplateReissueData> {
  return request.post(`/api/applets/nameplate/apply`, params)
}

//重新申请铭牌
export function reConfirmNameplateReissue(
  params: ConfirmNameplateReissueParams,
  guid: string
): Promise<confirmNameplateReissueData> {
  return request.post(
    `
/api/applets/nameplate/re_sumbit/${guid}`,
    params
  )
}

// 确认收货
export function receiptNameplateReissue(guid: string): Promise<confirmNameplateReissueData> {
  return request.post(`/api/applets/nameplate/confirm_receipt/${guid}`)
}

// 取消单据
export function cancelNameplateReissue(guid: string): Promise<void> {
  return request.post(`/api/applets/nameplate/cancel/${guid}`)
}
// 铭牌支付
export function payNameplateReissue(
  guid: string,
  param: PayNameplateRessiuePrams
): Promise<PayNameplateReissueResult> {
  return request.post(`/api/applets/nameplate/pay/${guid}`, param)
}
// 铭牌补办提交发票信息
export function submitNameplateReissueOrderInvoiceInfo(
  guid: string,
  params: OrderSubmitInvoiceData
): Promise<void> {
  return request.post(`/api/applets/nameplate/${guid}/invoice_apply_info`, params)
}
// 铭牌支付结果查询
export function payNameplateReissueResult(pay_order_no: string): Promise<{
  status: number
}> {
  return request.get(`
/api/applets/nameplate/pay_info?pay_order_no=${pay_order_no}`)
}

// 校验地面站编码
export function validateGroundStation(serial_number: string): Promise<{
  status: number
}> {
  return request.get(`
/api/applets/common/product/find?serial_number=${serial_number}`)
}
